module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/thurston_cover.58a3783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/thurston_cover.jpg
// module id = tlfe
// module chunks = 1